import React, { Component } from 'react';
import config from './../../config';

class LockScreen extends Component {
    constructor(props) {
        super(props);
        this.timeout = null;
    }

    componentDidMount() {
        const self = this;
        if (self.timeout) {
            clearTimeout(self.timeout);
        }
        self.timeout = setTimeout(() => {
            self.props.closeLockScreen();
        }, 1000 * config.TEAM_LOCK_SCREEN_CLOSE_TIMEOUT);
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);
    }

    render() {
        return <div className="si-modal-wrap" onClick={() => this.props.closeLockScreen()}>
            <div className="si-common-popup si-team-locked-popup">
                <div className="si-popup-body si-flexBox">
                    <div className="si-logo-wrap">
                        <span><i className="icon-ucl-lock"></i></span>
                    </div>
                    <div className="si-details-wrap">
                        <div className="si-title">{this.props.teamLockTitle}</div>
                        <div className="si-more-info"><span>{this.props.teamLockDesc}</span></div>
                    </div>
                </div>
            </div>
        </div>
    }
}

export default LockScreen;


// WEBPACK FOOTER //
// ./src/components/manage-team/Lock-Screen.js